<template>
  <div>
    <van-cell :title="$t('Show archieved')">
      <template #title>
        <div class="center-setting">{{ $t("Filters") }}:</div>
      </template>
      <template #right-icon>
        <div class="filtertags-wrapper">
          <span
            class="filtertags"
            :class="{ active: displayFilter == item }"
            v-for="item in displayFilters"
            :key="item"
            @click="displayFilterChange(item)"
          >
            {{ $t(item) }}
          </span>
        </div>
      </template>
    </van-cell>

    <van-collapse
      class="studentPlacementTests"
      v-model="expanded"
      accordion
      v-for="(test, idx) in inviteListPlacementTestResults.results"
      :key="`tests-${idx}`"
    >
      <van-collapse-item
        :name="idx"
        v-if="test.test_results && test.test_results.length > 0"
        ><template #title>
          <h3 class="title">"{{ test.name }}" - {{ test.level }}</h3>
        </template>
        <template #value>
          {{ getResults(test.test_results).length }} /
          {{ test.test_results ? test.test_results.length : 0 }}
        </template>
        <div
          class="studentPlacementTestsResultRow"
          v-for="{ id, score, user, seen, created } in getResults(
            test.test_results
          )"
          :key="`result-${id}`"
        >
          <section class="left-section">
            <DonutChart :percent="score" />
            <!-- <div class="score">{{ score }}%</div> -->
            <div>
              <span class="userName">'{{ user.name }}' ({{ user.email }})</span>
              <div class="timestamps">
                <span>{{ formatDatetime(created) }}</span>
                <span>({{ formatFromNow(created) }})</span>
              </div>
            </div>
          </section>
          <section class="actions">
            <i
              class="fas fa-check-circle"
              v-if="seen"
              @click="toggleSeen(id)"
            ></i>
            <i class="far fa-circle" v-if="!seen" @click="toggleSeen(id)"></i>
            <router-link
              class="reviewBtn"
              :to="{
                name: 'review-placement-test-result',
                params: { result_id: id, test_id: test.id }
              }"
            >
              <i class="fas fa-comment-alt"></i>
              <!-- {{ $t("Review test") }} -->
            </router-link>
          </section>
        </div>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import DonutChart from "@/components/chart/DonutChart";
import formatTS from "@/mixins/momentMixin";
import axios from "@/helpers/axios";

export default {
  name: "PlacementTestResults",
  mixins: [formatTS],
  components: { DonutChart },
  computed: {
    ...mapState("placementTest", ["inviteListPlacementTestResults"])
  },
  methods: {
    ...mapActions("placementTest", ["getInviteListPlacementTestResults"]),
    getResults(results) {
      if (this.displayFilter == "All") {
        return results;
      }
      return results.filter(item =>
        this.displayFilter == "New" ? !item.seen : item.seen
      );
    },
    toggleSeen(id) {
      axios
        .post(`stats/toggle-seen-placement-test-results/${id}`)
        .then(() => {
          this.getInviteListPlacementTestResults();
        })
        .catch(err => {
          console.log(err);
        });
    },
    displayFilterChange(filter) {
      this.displayFilter = filter;
    }
  },
  data() {
    return {
      displayFilter: "New",
      expanded: [],
      displayFilters: ["All", "Archived", "New"]
    };
  },
  created() {
    this.getInviteListPlacementTestResults();
  }
};
</script>

<style lang="scss">
.center-setting {
  display: flex;
  align-items: center;
  height: 100%;
}
.filtertags-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.filtertags {
  margin: 5px;
  padding: 5px 8px;
  border-radius: 3px;
  border: 1px solid #11b97f;
  cursor: pointer;
  /* background:  */
  color: #11b97f;
}
.filtertags.active {
  background: #11b97f;
  color: #d1fae4;
}
.studentPlacementTestsResultRow {
  display: flex;
  justify-content: space-between;
  color: #2c3e50;
  padding: 10px 12px;
  padding-right: 12px;

  .actions {
    display: flex;
    align-self: center;
    > i {
      margin-right: 5px;
    }
  }

  &:nth-child(even) {
    background: #f3f3f3;
  }
  a {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .userName {
    font-size: 1.1rem;
    padding: 4px 12px;
    padding-bottom: 0;
  }
  .timestamps {
    padding-left: 12px;
    font-size: 0.8rem;
  }
  .score {
    font-size: 1.5rem;
    font-weight: bold;
  }
  .left-section {
    display: flex;
    align-items: center;
  }
}
</style>
